import React, { useState } from 'react';
import './BetaBanner.css';
import { useBanner } from '../utils/context/BannerContext';

function BetaBanner() {
  const { isBannerVisible, setIsBannerVisible } = useBanner();

  if (!isBannerVisible) {
    return null;
  }

  const bannerText = "Qoach.io is live in beta as we build and test the platform with early coaches. You're welcome to explore, browse, and try features — but please note this is a trial phase, and things may change or break as we improve.\nPaid coaching, hiring, and commercial usage will open in March. Thank you for being part of our early journey.";

  return (
    <div className="fixed top-0 left-0 right-0 z-[10000] w-full bg-amber-400 text-gray-900 shadow-md" style={{ padding: '8px 16px' }}>
      <div className="flex items-center justify-center gap-4 relative">
        <p className="text-xs font-medium m-0 leading-snug text-center flex-1 pr-12" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-wrap' }}>
          {bannerText}
        </p>
        <button
          onClick={() => setIsBannerVisible(false)}
          className="absolute right-4 flex-shrink-0 text-gray-900 hover:text-gray-700 font-bold text-lg leading-none"
          aria-label="Close banner"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default BetaBanner;
